import Invite from '@components/pages/invite';
import { NextSeo } from 'next-seo';

const InvitePage = ({ openGraph }) => {
  return (
    <>
      <NextSeo
        title="Fair Square - You're Invited!"
        description="Your medicare advisor for life."
        openGraph={openGraph}
      />
      <Invite />
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {
      openGraph: {
        type: 'website',
        locale: 'en_US',
        url: 'https://www.fairsquaremedicare.com/invite',
        site_name: 'Fair Square Medicare',
        description: 'Your medicare advisor for life.',
        images: [
          {
            url: `${process.env.BASE_URL}/invite.png`,
            width: 1200,
            height: 630,
            alt: 'Fair Square Invitation',
          },
        ],
      },
    },
  };
}

export default InvitePage;
